import React from 'react'
import i18n from 'i18next'
import { observer } from 'mobx-react'

import Modal from '../../../UniformComponents/Modal'
import ModalFooter from '../../../UniformComponents/ModalFooter'
import Button from '../../../UniformComponents/Button'

const EmailListWarningModal = ({ distributeStore }) => (
    <Modal
        show={distributeStore.emailListWarningModalVisible}
        onClose={distributeStore.hideEmailListWarningModal}
    >
        <div>
            <i className="fal fa-circle-exclamation" style={{ fontSize: 36, color: 'red' }} />

            <h2>{i18n.t('distributionEmailListWarningModal.title')}</h2>

            <p>{i18n.t('distributionEmailListWarningModal.subtitle')}</p>
        </div>

        <ModalFooter>
            <div>
                <Button cssClass="regular primary" onClick={distributeStore.hideEmailListWarningModal}>
                    {i18n.t('Close')}
                </Button>
            </div>
        </ModalFooter>
    </Modal>
)

export default observer(EmailListWarningModal)
